import { storyblokEditable } from "@storyblok/react";

const TextImageSmaller = ({ blok }) => (
    <div className="wrap">
    <div className="textimagesmaller-wrap flex inner-wrap"{...storyblokEditable(blok)}>
      <div className="textimagesmaller-content flex flex-col">
        <h2 className="text-3xl">{blok.subheadline}</h2>
        <div className="textimagesmaller-img ml-8">
        <img className="hide-mobile pb-4" src={blok.image.filename} alt={blok.image.alt} />

      </div>
        <p>
          {blok.text}
        </p>
        {/* <div>
          <button>{blok.button}</button>  
        </div> */}
        
      </div>
      <div className="textimagesmaller-img ml-8">
        <img className="hide-desktop" src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
    </div>
);

export default TextImageSmaller; 